<template>
  <van-form ref="vanForm" validate-first class="mode">
    <van-cell-group>
      <template v-for="(item, key) of form">
        <van-field
          v-if="item.isSelect"
          :key="item.name"
          input-align="right"
          v-model="item.text"
          :label="item.name"
          :rules="item.value ? item.rules : []"
          placeholder="请选择"
          right-icon="arrow"
          readonly
          @click="showPop(item.name, key)"
        />
        <van-field
          v-else-if="item.isDate"
          :key="item.name"
          input-align="right"
          v-model="item.text"
          :label="item.name"
          :rules="item.value ? item.rules : []"
          placeholder="请选择"
          right-icon="arrow"
          readonly
          @click="showDatePop(item.name, key)"
        />
        <van-field
          v-else
          :key="item.name"
          input-align="right"
          v-model="item.text"
          :label="item.name"
          :rules="item.value ? item.rules : []"
          placeholder="请输入"
          @input="val => changeValue(val, key)"
        />
      </template>
    </van-cell-group>
    <van-cell-group>
      <template v-for="(item, key) of form1">
        <van-field
          :key="item.name"
          class="qz-textarea"
          v-model="item.text"
          rows="3"
          autosize
          :label="item.name"
          input-align="left"
          type="textarea"
          placeholder="请输入"
          show-word-limit
          maxlength="200"
          @input="val => changeValue1(val, key)"
        />
      </template>
    </van-cell-group>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.title"
        show-toolbar
        :columns="valueList.columns"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.field);
          }
        "
      />
    </van-popup>
    <van-popup v-model="showDate" round position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :title="valueList.title"
        :min-date="minDate"
        @confirm="
          (value, index) => {
            onConfirmDate(value, index, valueList.field);
          }
        "
      />
    </van-popup>
  </van-form>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form1: {
        gznr: {
          name: "工作内容",
          text: "",
          value: ""
        }
      },
      form: {
        szdw: {
          name: "所在单位名称",
          text: "",
          value: ""
        },
        qsrq: {
          name: "起始日期",
          text: "",
          value: "",
          isDate: true
        },
        zzrq: {
          name: "结束日期",
          text: "",
          value: "",
          isDate: true
        },
        drzw: {
          name: "担任职务",
          text: "",
          value: "",
          isSelect: true
        },
        zmr: {
          name: "证明人",
          text: "",
          value: ""
        }
      },
      show: false,
      valueList: {
        title: "",
        field: "",
        columns: []
      },
      columns: {},
      currentDate: new Date(),
      minDate: new Date(1900, 0, 1),
      showDate: false
    };
  },
  created() {
    this.getList();
  },
  methods: {
    changeValue1(val, field) {
      this.form1[field].value = val;
    },
    changeValue(val, field) {
      this.form[field].value = val;
    },
    async saveData() {
      this.$refs.vanForm.validate().then(
        async () => {
          if (Number(this.form.qsrq.value) >= Number(this.form.zzrq.value)) {
            this.$toast.fail("结束日期要在起始日期之后！");
            return;
          }
          let params = {
            type: "jl",
            szdw: this.form.szdw.value,
            qsrq: this.form.qsrq.value,
            zzrq: this.form.zzrq.value,
            drzw: this.form.drzw.value,
            zmr: this.form.zmr.value,
            gznr: this.form1.gznr.value,
            xs0102id: this.info.xs0102id
          };

          const res = await Api.saveXjxx(params);
          if (res.code == 1) {
            if (this.info.type === "add") {
              this.$toast.success("学籍" + this.info.title + "增加已提交");
            } else {
              this.$toast.success("学籍" + this.info.title + "修改已提交");
            }
            setTimeout(() => {
              this.$router.replace(
                "/xsxxxgsq/index?active=" + this.info.active
              );
            }, 1500);
          }
        },
        () => {}
      );
    },
    async getList() {
      const res = await Api.findStudentInfo({
        type: "jl",
        xs0102id: this.info.xs0102id
      });
      if (res.code === "1") {
        let message = res.data.jlInfo;
        let defaultDrzw = 0;
        // 担任职务
        this.columns.drzw = [
          {
            values: res.data.selectDataMap.zw.map((item, index) => {
              if (this.info.type === "update" && item.dm === message.zwdm) {
                defaultDrzw = index;
              }
              return {
                text: item.dmmc,
                value: item.dm
              };
            }),
            defaultIndex: defaultDrzw
          }
        ];

        if (this.info.type === "update") {
          this.form = {
            szdw: {
              name: "所在单位名称",
              text: message.szdw,
              value: message.szdw
            },
            qsrq: {
              name: "起始日期",
              text:
                message.qsrq.substr(0, 4) +
                "年" +
                message.qsrq.substr(4, 2) +
                "月" +
                message.qsrq.substr(6, 2) +
                "日",
              value: message.qsrq,
              isDate: true
            },
            zzrq: {
              name: "结束日期",
              text:
                message.zzrq.substr(0, 4) +
                "年" +
                message.zzrq.substr(4, 2) +
                "月" +
                message.zzrq.substr(6, 2) +
                "日",
              value: message.zzrq,
              isDate: true
            },
            drzw: {
              name: "担任职务",
              text: message.zwmc,
              value: message.zwdm,
              isSelect: true
            },
            zmr: {
              name: "证明人",
              text: message.zmr,
              value: message.zmr
            }
          };
          this.form1 = {
            gznr: {
              name: "工作内容",
              text: message.gznr,
              value: message.gznr
            }
          };
        }
      }
    },
    // 弹出选择器
    showPop(title, field) {
      this.show = true;
      this.valueList.title = title;
      this.valueList.field = field;
      this.valueList.columns = this.columns[field];
    },
    // 选择确认
    onConfirm(value, index, field) {
      this.show = false;
      this.form[field].text = value[0].text;
      this.form[field].value = value[0].value;
      //   this.getList();
    },
    showDatePop(title, field, flag) {
      if (this.form[field].value) {
        let yy = this.form[field].value.substr(0, 4);
        let mm = this.form[field].value.substr(4, 2);
        let dd = this.form[field].value.substr(6, 2);
        this.currentDate = new Date(yy, mm - 1, dd);
      } else {
        this.currentDate = new Date();
      }

      this.showDate = true;
      this.valueList.title = title;
      this.valueList.field = field;
    },
    onConfirmDate(date, index, field) {
      this.showDate = false;
      let yy = date.getFullYear();
      let mm =
        Number(date.getMonth()) + 1 < 10
          ? "0" + (Number(date.getMonth()) + 1)
          : Number(date.getMonth()) + 1;
      let dd = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      this.form[field].text = yy + "年" + mm + "月" + dd + "日";
      this.form[field].value = yy + "" + mm + "" + dd;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/newPages/student/xsxxxgsq/mode/jl.vue